/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 17:15:03
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-22 13:44:57
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Select/OriginalSelect.tsx
 */
import { Select } from 'antd';
import React from 'react';
import css from './Select.less';

import FormItem from '@/src/components/Antd/FormItem/FormItem';
import { EnumFormItemStatus } from 'src/types/common/validation';
import { generateOptions } from './tools';

import { getI18nFromGeneral } from '@/src/tools/tools';
import SearchSelect from './SearchSelect/SearchSelect';

export { SearchSelect, generateOptions };
// interface IProps {
//   optionsList?: OptionsList[];
//   rightBtn?: RightBtn;
//   size?;
//   value?;
//   onChange?;
//   status?: EnumFormItemStatus;
//   help?: string | ReactNode;
//   optionsGroupList?: OptionsGroupList[];
//   error?: boolean;
// }

const _Select = (props) => {
  const {
    size,
    value,
    onChange,
    // status,
    help,
    error,
    selectClassName,
    dropdownClassName,
    children,
    formProps,
    ...rest
  } = props;

  return (
    <FormItem
      {...formProps}
      {...(error && {
        status: EnumFormItemStatus.error,
        help: help || getI18nFromGeneral('general.antd.DatePicker.item_help'),
      })}>
      <div className={css.selectContain}>
        <Select
          //placeholder={'hello hello'}
          size={size}
          value={value}
          onChange={onChange}
          className={`${css.select} ${selectClassName || ''}`}
          dropdownClassName={`${css.dropdown} ${dropdownClassName || ''}`}
          {...rest}>
          {children}
        </Select>
      </div>
    </FormItem>
  );
};
// const _Option = (props: any) => {
//   const { children, ...rest } = props;
//   return <Select.Option {...rest}>{children}</Select.Option>;
// };

// const _OptionGroup = (props: any) => {
//   const { children, ...rest } = props;
//   return <Select.OptGroup {...rest}>{children}</Select.OptGroup>;
// };

_Select.Option = Select.Option;
const _Option = _Select.Option;
_Select.OptionGroup = Select.OptGroup;
export default _Select;
export { _Option as Option, _Select as Select };
